<template>
  <v-card class="pa-4">
    <h3>{{ label }}</h3>
    <p class="my-2 mx-1">{{subLabel}}  </p>
    <!-- <div>-----------------------Rows</div>
    {{ rows }} -->
    <!--     <div>-----------------------Columns</div>
    {{ columns }} -->
    <v-simple-table>
      <thead>
        <tr>
          <th v-if="dynamicRowAddAllow"></th>
          <th></th>
          <th v-for="col in columns" :key="col.name" class="text-center">
            {{ col.name }}
          </th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(row, index) in rows" :key="row.id">
          <td v-if="dynamicRowAddAllow">{{ index + 1 }}</td>
          <td>{{ row.name }}</td>
          <td v-for="col in columns" :key="col.name" class="text-center" style="vertical-align: middle;">
            <!-- <v-text-field v-model="row.values[col.id]" dense outlined hide-details
              style="max-width:120px;"></v-text-field> -->

            <component v-bind:is="col.json.cmpName" :ayar="{ ...col.json, value: row.values[col.id] }"
              v-model="row.values[col.id]">
              <template v-slot:edit v-if="editProp">

                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-icon v-on="on" @click="JsonClick(col.json)">
                      mdi-cog
                    </v-icon>
                  </template>
                  Düzenle
                </v-tooltip>

                <!-- <v-btn color="success" @click="JsonClick(col.json)">=</v-btn> -->
              </template>
            </component>



          </td>
          <td v-if="dynamicRowAddAllow"><v-btn color="success" @click="btnRowAddClick" icon><v-icon>mdi
                mdi-plus</v-icon> </v-btn>
          </td>
          <td v-if="dynamicRowAddAllow"><v-btn color="success" @click="btnRowDeleteClick(row)" icon><v-icon>mdi
                mdi-close</v-icon> </v-btn>
          </td>
        </tr>
      </tbody>
    </v-simple-table>

    <v-checkbox v-model="valid" v-show="false" :rules="listRules2()"></v-checkbox>

    <div style="color:red;" v-if="!valid">
      Lütfen boş soru bırakmayınız.
    </div>



  </v-card>
</template>

<script>
import { textMatrixSF } from '@/plugins/FieldDataFormat.js'
import FormOgeService from '@/services/FormOgeService';
import VText from './VText.vue';
import VSelect from './VSelect.vue';
import VDate from './VDate.vue';
import VNumber from './VNumber.vue';
import VMail from './VMail.vue';
import VDateHtml from './VDateHtml.vue';

export default {
  name: "MultipleRadioGridEditor",
  components: { VText, VSelect, VDate, VNumber, VMail, VDateHtml },
  data() {
    return {
      valid: true,
      id: "",
      value: [],
      label: "",
      required: false,
      color: null,
      disable: false,
      hint: "",
      items: [],
      rows: [],
      columns: [],
      dynamicRowAddAllow: false,
subLabel:"",
maxRowCount:5,
minRowCount:1,

      // rules: [v => !!v || 'Name is required'],
      placeholder: "",


    }
  },
  props: {
    editProp: {
      default() {
        return false
      },
      type: Boolean
    },
    ayar: {
      // default: '{"title":"","description":""}',
      default() {
        return textMatrixSF;
      },
      type: Object
    },
    rules: {
      default() {
        return [v => !!v || 'Name is required'];
      },
      type: Array

    }

  },
  methods: {
    JsonClick(json) {
      let this2 = this;
      setTimeout(function () {
        console.log("emit", this2);
        this2.$emit('setClick', json);

      }, 500);
    },
    btnRowAddClick() {


       let rowValidFun=m=>true;
      if (this.dynamicRowAddAllow){
        let min = parseInt(this.minRowCount);
        let max = parseInt(this.maxRowCount);
        min=Number.isNaN(min) ? 1 : min;
        max=Number.isNaN(max) ? 100 : max;


       let izin= this.rows.length >= min && this.rows.length <= max ;
       if (!izin){
        this.$toast.error("Satır sayısı "+min+" ile "+max+" arasında olmalıdır.");
        return;
       }


      }

      FormOgeService.newGuid().then((result) => {
        let value = {}
        this.columns.forEach(element => {
          value[element.id] = "";

        });

        this.rows.forEach(row => {

          this.columns.forEach(elementColumn => {
            if (!Object.prototype.hasOwnProperty.call(row.values, elementColumn.id))
            {
              row.values[elementColumn.id] = "";
            }

          });


        });

        this.rows.push({ id: result.data, name: "", values: value, })

      }).catch((err) => {
        this.$toast.error("Kopyalama işleminde hata oluşmaktadır.");

      });



    },
    btnRowDeleteClick(row) {


      let selectedRowIndex = this.rows.findIndex((x) => x.id === row.id);

      this.rows.splice(selectedRowIndex, 1);



    },
    listRules2() {

      if (this.ayar.required) {
        console.log("This.rowa:", this.rows);


        this.valid = this.rows.every(m => Object.values(m.values).every(v => v.length > 0));
        //this.valid = this.rows.every(m => m.values.length > 0);
      }
      else {
        this.valid = true;
      }
      // let rowValidFun=m=>true;
      // if (this.dynamicRowAddAllow){
      //   let min = parseInt(this.minRowCount);
      //   let max = parseInt(this.maxRowCount);
      //   min=Number.isNaN(min) ? 1 : min;
      //   max=Number.isNaN(max) ? 100 : max;


      //  rowValidFun= v => this.rows.length >= min && this.rows.length <= max || 'Bu alan zorunludur'

      // }

      return [v => this.valid || 'Bu alan zorunludur']
    },
    dataBind(json) {
      //console.log("Vtext Json", json);
      // let ayarJson = JSON.parse(jsonStr);
      this.title = json.title;


      this.hint = json.hint;
      this.label = json.label;
      this.required = json.required;

      this.disable = json.disable;
      this.id = json.id;
            for (let index = 0; index < json.rows.length; index++) {
  const element = json.rows[index];
  if (!("disable" in element)) {
 element.disable = false;
}
  
}
      this.rows = json.rows;
      this.columns = json.columns
      this.header = json.header;
      this.dynamicRowAddAllow = json.dynamicRowAddAllow;
this.subLabel=json.subLabel;  
this.minRowCount=json.minRowCount;  
this.maxRowCount=json.maxRowCount;  
      // this.value=  json.value.lenght>0 ? json.value.split(',') : [];
      // this.value=  json.value;


    }
  },
  created() {
    this.dataBind(this.ayar);
    if (this.rows.length == 0) {
      let value = {}
      this.columns.forEach(element => {
        value[element.id] = "";

      });
      FormOgeService.newGuid().then((result) => {

        this.rows.push({ id: result.data, name: "1.Satır", values: value, })
      }).catch((err) => {
        this.$toast.error("Kopyalama işleminde hata oluşmaktadır.");

      });

    }
    //console.log("Created Value:",this.ayar.value.length);
    //this.value=  this.ayar.value.length>0 ? this.ayar.value.split(',') : [];
  },
  watch: {


    // value(x, y) {
    //   this.$emit('input', x);
    //   //console.log("Rules",x,y);
    // },
    ayar: {
      immediate: true,
      handler(newVal, oldVal) {
       //  console.log("VText Matrix Jandler:",newVal);
        // if  (newVal.required){
        // newVal.rules.push(value => !!value || 'Bu alana boş bırakılamaz.')
        // }
        //console.log("ayar HAndler:", newVal);
        this.dataBind(newVal);
        //this.slots.forEach(slot => {
        //    if (slot.availability > 10) slot.availability = 10;
        //});
        this.$emit('input', JSON.stringify(newVal.rows));
      },
      deep: true
    }

  },
};
</script>
<style scoped>
::v-deep .v-input--radio-group__input {
  display: block;
  text-align: center;
}

::v-deep .v-radio {
  align-items: center;
  display: block;
  height: auto;
  outline: none;
}

.vertical-header {
  writing-mode: vertical-lr;
  transform: rotate(180deg);
  text-align: center;
  white-space: nowrap;
  height: 150px;
}
</style>